import type { InvoiceDetailed } from "./Invoice.js";
import type { FileAccessTokenProvider } from "../../file/index.js";
import { config } from "../../config/config.js";

export class InvoicePdfAccessTokenProvider implements FileAccessTokenProvider {
  public readonly invoice: InvoiceDetailed;

  public constructor(invoice: InvoiceDetailed) {
    this.invoice = invoice;
  }

  public getDownloadToken(ignoredFileId: string) {
    return config.behaviors.invoice.getFileAccessToken(
      this.invoice.id,
      this.invoice.customer.id,
    );
  }
}
